module.exports = __webpack_public_path__ + "static/img/jtkg.ba38ab1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/jtkg.jpg
// module id = hjoP
// module chunks = 1